import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'jomfruin';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyCr3lLGBJYcBKrOeiGFUUnvAK1V72CKzgU',
		authDomain: 'luca-6c304.firebaseapp.com',
		projectId: 'luca-6c304',
		storageBucket: 'luca-6c304.firebasestorage.app',
		messagingSenderId: '452572869469',
		appId: '1:452572869469:web:0fdc74b5aad45f80d5aeb4',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '3000032977',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
